// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"_o-z","slideIn":"ap-z"};